<template>
  <div class="md:flex flex-col py-6 px-4 rounded-lg border border-gray-200 shadow-sm">
    <h3 class="block mt-1">{{ name }}</h3>
    <p v-if="description" class="mt-2">{{ description }}</p>
    <span class="text-lg">
      <span v-if="price" class="flex mt-4 text-xl uppercase tracking-wide text-teal-500 font-bold">{{ price }}€</span>
      <span v-if="prices" class="flex flex-col mt-4">
        <span v-for="price in prices" :key="price.index" class="pb-2">
          <span class="uppercase tracking-wide text-teal-500 font-bold">{{ price.value }}€</span>
          <span class="text-gray-400 px-2">/</span>
          <span class="tracking-wide">{{ price.name }}</span>
          <span class="tracking-wide"> {{ price.description }}</span>
        </span>
      </span>
    </span>
  </div>
</template>

<script>
export default {
  name: 'PriceCard',
  props: {
    name: String,
    description: String,
    price: Number,
    prices: Array,
  },
}
</script>
